import { reactive } from 'vue'

import pusherScript, { isPusherInstalled } from '@/modules/OktellModule/pusher'
import useNotifications from '@/common/composable/useNotifications'
import { oktell } from '@/core/realisations/oktell.realisation'

type pusherOptions = {
    successCallback: CallableFunction
    failureCallback: CallableFunction
}

export default function (options: pusherOptions) {
    let pusher = null as any

    const notifications = useNotifications()

    const state = reactive({
        is_token_loading: false,
        is_token_failed: false,
        token: null as string | null,
        //
        is_instance_loading: false,
        is_instance_failed: false,
    })

    const loadPusherToken = async () => {
        try {
            state.is_token_loading = true

            const response = await oktell.getWhatsappToken()
            state.token = response.data.accessToken

            state.is_token_failed = false
        } catch (error) {
            notifications.notifyError({
                error,
                title: 'При получении токена для интеграции чата произошла ошибка',
            })

            console.error(error)
            state.is_token_failed = true
        } finally {
            state.is_token_loading = false
        }
    }

    const createPusherInstance = () => {
        return new Pusher('ChatsAppApiProdKey', {
            wsHost: 'socket.chatapp.online',
            wssPort: 6001,
            disableStats: true,
            authEndpoint: 'https://api.chatapp.online/broadcasting/auth',
            auth: {
                headers: {
                    Authorization: state.token as string,
                },
            },
            enabledTransports: ['ws'],
            forceTLS: true,
        })
    }

    const isPusherInstanceCreated = (): boolean => {
        return Boolean(pusher)
    }

    const onScriptInstalled = async () => {
        const isHasPusherInstance = isPusherInstanceCreated()

        state.is_instance_loading = true
        state.is_instance_failed = false

        if (isHasPusherInstance) {
            state.is_instance_loading = false
            state.is_instance_failed = false

            options.successCallback(pusher)
            return
        } else {
            try {
                await loadPusherToken()

                if (!state.token) {
                    console.warn('[usePusher.ts/onScriptInstalled] Token is undefined')
                    notifications.notifyError({
                        error: null,
                        title: 'При интеграции чата произошла ошибка',
                    })
                    options.failureCallback()

                    return
                }

                pusher = createPusherInstance()
                options.successCallback(pusher)

                state.is_instance_failed = false
            } catch (error) {
                state.is_instance_failed = true

                console.error(error)
                notifications.notifyError({ error, title: 'При интеграции чата произошла ошибка' })

                options.failureCallback(error)
            } finally {
                state.is_instance_loading = false
            }
        }
    }

    const onScriptFailure = (error: any) => {
        options.failureCallback(error)
    }

    const installScript = async () => {
        const isScriptInstalled = pusherScript.isPusherInstalled()

        if (isScriptInstalled) {
            onScriptInstalled()
        } else {
            pusherScript.installPusher(onScriptInstalled, onScriptFailure)
        }
    }

    return {
        pusher,
        state,
        installScript,
    }
}
